export default "__VITE_ASSET__f17a89a1__"